import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { UserGroupAddComponent } from './user-group/user-group-add/user-group-add.component';
import { UserGroupEditComponent } from './user-group/user-group-edit/user-group-edit.component';
import { UserAdminAddComponent } from './user-admin/user-admin-add/user-admin-add.component';
import { UserCabangAddComponent } from './user-cabang/user-cabang-add/user-cabang-add.component';
import { KolektorPenagihanDetailComponent } from
  './kolektor/kolektor-penagihan/kolektor-penagihan-detail/kolektor-penagihan-detail.component';
import { MemorandumDetailComponent } from './credit-analys/memorandum/memorandum-detail/memorandum-detail.component';
import { MemorandumAppDetailComponent } from './credit-analys/approval-memorandum/memorandum-app-detail/memorandum-app-detail.component';
// import { PpAddComponent } from './pp/pp-add/pp-add.component';
import { PpAssignListComponent } from './pp/add-pp/pp-assign-list/pp-assign-list.component';
import { PpAssignAddComponent } from './pp/add-pp/pp-assign-add/pp-assign-add.component';
import { ListPpComponent } from './pp/assign-pp/list-pp/list-pp.component';
import { AddPpComponent } from './pp/assign-pp/add-pp/add-pp.component';
import { ValidasiPpComponent } from './pp/validasi-pp/validasi-pp/validasi-pp.component';
import { AssignSurveyorComponent } from './assign/assign-surveyor/assign-surveyor.component';
import { DelegasiListComponent } from './delegasi/delegasi-list/delegasi-list.component';
import { DelegasiRiwayatComponent } from './delegasi/delegasi-riwayat/delegasi-riwayat.component';
import { ReportNasabahComponent } from './report/sales-report/report-nasabah/report-nasabah.component';
import { HasilSurveyComponent } from './report/surveyor-report/hasil-survey/hasil-survey.component';
import { ReportPerformanceComponent } from './report/sales-report/report-performance/report-performance.component';
import { ReportPerformanceColComponent } from './report/collector-report/report-performance-col/report-performance-col.component';
import { CompanyGuard } from './core/company/company.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'binding-company',
    loadChildren: () =>
      import('./binding-company/binding-company.module').then(
        (m) => m.BindingCompanyPageModule,
      ),
  },
  {
    path: 'folder/:id',
    loadChildren: () =>
      import('./folder/folder.module').then((m) => m.FolderPageModule),
  },
  {
    path: 'login',
    canActivate: [CompanyGuard],
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'leads',
    loadChildren: () =>
      import('./leads/leads.module').then((m) => m.LeadsPageModule),
  },
  {
    path: 'prospect',
    loadChildren: () =>
      import('./prospect/prospect.module').then((m) => m.ProspectPageModule),
  },
  {
    path: 'prospek-pre-credit-nasabah',
    loadChildren: () =>
      import('./prospek-pre-credit-nasabah/prospek-pre-credit-nasabah.module').then(
        (m) => m.ProspekPreCreditNasabahPageModule,
      ),
  },
  {
    path: 'prospek-precredit-nasabah',
    loadChildren: () =>
      import('./prospek-pre-credit-nasabah/prospek-pre-credit-nasabah.module').then(
        (m) => m.ProspekPreCreditNasabahPageModule,
      ),
  },
  {
    path: 'pre-credit',
    loadChildren: () =>
      import('./prospek-pre-credit-nasabah/prospek-pre-credit-nasabah.module').then(
        (m) => m.ProspekPreCreditNasabahPageModule,
      ),
  },
  {
    path: 'pre-credit-nasabah',
    loadChildren: () =>
      import('./prospek-pre-credit-nasabah/prospek-pre-credit-nasabah.module').then(
        (m) => m.ProspekPreCreditNasabahPageModule,
      ),
  },
  {
    path: 'prospek-pre-credit',
    loadChildren: () =>
      import('./prospek-pre-credit-nasabah/prospek-pre-credit-nasabah.module').then(
        (m) => m.ProspekPreCreditNasabahPageModule,
      ),
  },
  {
    path: 'leads-update-status',
    loadChildren: () =>
      import('./leads-update-status/leads-update-status.module').then(
        (m) => m.LeadsUpdateStatusPageModule,
      ),
  },
  {
    path: 'leads-detail',
    loadChildren: () =>
      import('./leads-detail/leads-detail.module').then(
        (m) => m.LeadsDetailPageModule,
      ),
  },
  {
    path: 'assignment-partner',
    loadChildren: () =>
      import('./assignment-partner/assignment-partner.module').then(
        (m) => m.AssignmentPartnerPageModule,
      ),
  },
  {
    path: 'credit-checking',
    loadChildren: () =>
      import('./pengajuan-slik/pengajuan-slik.module').then(
        (m) => m.PengajuanSlikPageModule,
      ),
  },
  {
    path: 'pengajuan-slik',
    loadChildren: () =>
      import('./pengajuan-slik/pengajuan-slik.module').then(
        (m) => m.PengajuanSlikPageModule,
      ),
  },
  {
    path: 'daftar-checking',
    loadChildren: () =>
      import('./daftar-checking/daftar-checking.module').then(
        (m) => m.DaftarCheckingPageModule,
      ),
  },
  {
    path: 'arsip',
    loadChildren: () =>
      import('./arsip/arsip.module').then((m) => m.ArsipPageModule),
  },
  {
    path: 'list-partner',
    loadChildren: () =>
      import('./list-partner/list-partner.module').then(
        (m) => m.ListPartnerPageModule,
      ),
  },
  {
    path: 'daftar-kehadiran',
    loadChildren: () =>
      import('./kehadiran/kehadiran.module').then((m) => m.KehadiranPageModule),
  },
  {
    path: 'daftar-pengajuan-izin',
    loadChildren: () =>
      import('./izin/izin.module').then((m) => m.IzinPageModule),
  },
  {
    path: 'explore',
    loadChildren: () =>
      import('./explore/explore.module').then((m) => m.ExplorePageModule),
  },
  {
    path: 'listing-saya',
    loadChildren: () =>
      import('./listing-saya/listing-saya.module').then(
        (m) => m.ListingSayaPageModule,
      ),
  },
  {
    path: 'assignment-partner-add',
    loadChildren: () =>
      import('./assignment-partner-add/assignment-partner-add.module').then(
        (m) => m.AssignmentPartnerAddPageModule,
      ),
  },
  {
    path: 'assignment-detail',
    loadChildren: () =>
      import('./assignment-detail/assignment-detail.module').then(
        (m) => m.AssignmentDetailPageModule,
      ),
  },
  {
    path: 'error-maintenance',
    loadChildren: () =>
      import('./error-maintenance/error-maintenance.module').then(
        (m) => m.ErrorMaintenancePageModule,
      ),
  },
  {
    path: 'notification',
    loadChildren: () =>

      import('./notification/notification.module').then(
        (m) => m.NotificationPageModule,
      ),
  },
  {
    path: 'ganti-sales',
    loadChildren: () =>
      import('./ganti-sales/ganti-sales.module').then(
        (m) => m.GantiSalesPageModule,
      ),
  },
  {
    path: 'kehadiran-detail',
    loadChildren: () =>
      import('./kehadiran-detail/kehadiran-detail.module').then(
        (m) => m.KehadiranDetailPageModule,
      ),
  },
  {
    path: 'kolektor-tagihan',
    loadChildren: () =>
      import('./kolektor-tagihan/kolektor-tagihan.module').then(
        (m) => m.KolektorTagihanPageModule,
      ),
  },
  {
    path: 'kolektor-permohonan',
    loadChildren: () =>
      import('./kolektor-permohonan/kolektor-permohonan.module').then(
        (m) => m.KolektorPermohonanPageModule,
      ),
  },
  {
    path: 'kolektor-visit',
    loadChildren: () =>
      import('./kolektor-visit/kolektor-visit.module').then(
        (m) => m.KolektorVisitPageModule,
      ),
  },
  {
    path: 'kolektor-assignment',
    loadChildren: () =>
      import('./kolektor-assignment/kolektor-assignment.module').then(
        (m) => m.KolektorAssignmentPageModule,
      ),
  },
  {
    path: 'kolektor-hasil',
    loadChildren: () =>
      import('./kolektor-hasil/kolektor-hasil.module').then(
        (m) => m.KolektorHasilPageModule,
      ),
  },
  {
    path: 'kolektor-janji',
    loadChildren: () =>
      import('./kolektor-janji/kolektor-janji.module').then(
        (m) => m.KolektorJanjiPageModule,
      ),
  },
  {
    path: 'approval-uj',
    loadChildren: () =>
      import('./kolektor/approval-uj/approval-uj.module').then(
        (m) => m.ApprovalUjPageModule,
      ),
  },
  {
    path: 'kontrak',
    loadChildren: () =>
      import('./kolektor/kontrak/kontrak.module').then(
        (m) => m.KontrakPageModule,
      ),
  },
  {
    path: 'surveyor-approval-update',
    loadChildren: () =>
      import('./surveyor-approval-update/surveyor-approval-update.module').then(
        (m) => m.SurveyorApprovalUpdatePageModule,
      ),
  },
  {
    path: 'leads-detail-penjamin-modal',
    loadChildren: () =>
      import('./leads-detail-penjamin-modal/leads-detail-penjamin-modal.module').then(
        (m) => m.LeadsDetailPenjaminModalPageModule,
      ),
  },
  {
    path: 'surveyor-schedule-list',
    loadChildren: () =>
      import('./surveyor-schedule-list/surveyor-schedule-list.module').then(
        (m) => m.SurveyorScheduleListPageModule,
      ),
  },
  {
    path: 'surveyor-schedule-detail',
    loadChildren: () =>
      import('./surveyor-schedule-detail/surveyor-schedule-detail.module').then(
        (m) => m.SurveyorScheduleDetailPageModule,
      ),
  },
  {
    path: 'surveyor-schedule-form',
    loadChildren: () =>
      import('./surveyor-schedule-form/surveyor-schedule-form.module').then(
        (m) => m.SurveyorScheduleFormPageModule,
      ),
  },

  // ROUTING BARU
  {
    path: 'daftar-leads',
    loadChildren: () =>
      import('./leads/leads.module').then((m) => m.LeadsPageModule),
  },
  {
    path: 'credit-checking',
    loadChildren: () =>
      import('./pengajuan-slik/pengajuan-slik.module').then(
        (m) => m.PengajuanSlikPageModule,
      ),
  },
  {
    path: 'pengajuan-slik',
    loadChildren: () =>
      import('./pengajuan-slik/pengajuan-slik.module').then(
        (m) => m.PengajuanSlikPageModule,
      ),
  },
  {
    path: 'grup-menu',
    loadChildren: () =>
      import('./user-group/user-group.module').then(
        (m) => m.UserGroupPageModule,
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./setting/setting.module').then((m) => m.SettingPageModule),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./user-admin/user-admin.module').then(
        (m) => m.UserAdminPageModule,
      ),
  },
  {
    path: 'user-group-add',
    component: UserGroupAddComponent,
  },
  {
    path: 'user-group-edit',
    component: UserGroupEditComponent,
  },
  {
    path: 'user-admin-add',
    component: UserAdminAddComponent,
  },
  {
    path: 'user-cabang-add',
    component: UserCabangAddComponent,
  },
  {
    path: 'lapangan',
    loadChildren: () =>
      import('./user-lapangan/user-lapangan.module').then(
        (m) => m.UserLapanganPageModule,
      ),
  },
  {
    path: 'cabang',
    loadChildren: () =>
      import('./user-cabang/user-cabang.module').then(
        (m) => m.UserCabangPageModule,
      ),
  },
  {
    path: 'rekening',
    loadChildren: () =>
      import('./rekening/rekening.module').then((m) => m.RekeningPageModule),
  },
  {
    path: 'daftar-penagihan',
    loadChildren: () =>
      import('./kolektor/kolektor-penagihan/kolektor-penagihan.module').then(
        (m) => m.KolektorPenagihanPageModule,
      ),
  },
  {
    path: 'kolektor-penagihan-detail',
    component: KolektorPenagihanDetailComponent,
  },
  {
    path: 'kontrak-lunas',
    loadChildren: () =>
      import('./kolektor/kolektor-kontrak-lunas/kolektor-kontrak-lunas.module').then(
        (m) => m.KolektorKontrakLunasPageModule,
      ),
  },
  {
    path: 'angsuran-tertagih',
    loadChildren: () =>
      import('./kolektor/kolektor-angsuran-tertagih/kolektor-angsuran-tertagih.module').then(
        (m) => m.KolektorAngsuranTertagihPageModule,
      ),
  },
  {
    path: 'memorandum',
    loadChildren: () =>
      import('./credit-analys/memorandum/memorandum.module').then(
        (m) => m.MemorandumPageModule,
      ),
  },
  {
    path: 'memorandum-detail',
    component: MemorandumDetailComponent,
  },
  {
    path: 'produk',
    loadChildren: () =>
      import('./produk/produk.module').then((m) => m.ProdukPageModule),
  },
  {
    path: 'produk-add',
    redirectTo: 'produk/add',
    pathMatch: 'full',
  },
  {
    path: 'produk-edit',
    redirectTo: 'produk/edit',
    pathMatch: 'full',
  },
  {
    path: 'memorandum-detail',
    component: MemorandumDetailComponent,
  },
  {
    path: 'memorandum-app-detail',
    component: MemorandumAppDetailComponent,
  },
  {
    path: 'approval-memorandum',
    loadChildren: () =>
      import('./credit-analys/approval-memorandum/approval-memorandum.module').then(
        (m) => m.ApprovalMemorandumPageModule,
      ),
  },
  {
    path: 'checking-data',
    loadChildren: () =>
      import('./credit-analys/checking-data/checking-data.module').then(
        (m) => m.CheckingDataPageModule,
      ),
  },
  {
    path: 'checking-data-detail',
    loadChildren: () =>
      import('./credit-analys/checking-data-detail/checking-data-detail.module').then(
        (m) => m.CheckingDataDetailPageModule,
      ),
  },
  {
    path: 'permohonan',
    loadChildren: () =>
      import('./kolektor/permohonan/permohonan.module').then(
        (m) => m.PermohonanPageModule,
      ),
  },
  {
    path: 'tambah-assign-pp',
    component: PpAssignListComponent,
  },
  {
    path: 'tambah-assign-pp-add',
    component: PpAssignAddComponent,
  },

  {
    path: 'list-assign-pp',
    component: ListPpComponent,
  },
  {
    path: 'add-pp',
    component: AddPpComponent,
  },
  {
    path: 'validasi-pp',
    component: ValidasiPpComponent,
  },
  {
    path: 'assign-surveyor',
    component: AssignSurveyorComponent,
  },
  {
    path: 'delegasi',
    redirectTo: 'kelola-delegasi',
    pathMatch: 'full',
  },
  {
    path: 'kelola-delegasi',
    component: DelegasiListComponent,
  },
  {
    path: 'riwayat-pindah-kelompok',
    component: DelegasiRiwayatComponent,
  },
  {
    path: 'prospek-nasabah',
    component: ReportNasabahComponent,
  },
  {
    path: 'hasil-survey',
    component: HasilSurveyComponent,
  },
  {
    path: 'performance-sales',
    component: ReportPerformanceComponent,
  },
  {
    path: 'kinerja-collector',
    component: ReportPerformanceColComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      initialNavigation: 'disabled',
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
